import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import md5 from 'js-md5'
import urls from '../common/js/urls.js'

Vue.use(Vuex)

const state = {
  application_id: '',
  //登录
  user: {
    user_id: '',
    username: '',
    nickname: '',
    current_exam_type_id: '',
    is_fighting_user: 0,  //封闭班
    is_expound_user: 0,   //有申论上传权限
    image_url: '',
    sex: 0, //(1, '男'), (2, '女')
    token: '',
    type: 0, //(0, '普通用户'), (1, '老师'), (2, '助教'), (9, '测试帐号'),
    vip: 0,

  },
  is_register:'',//是否是新用户
  //首页
  index_nav: [],              //导航条
  current_page_id: 0,
  index_module_page_id: '0',
  pages: {
    my_course: {}
  }, //通用的页面数据
  isLoading:false
}

const store = {
  state,
  mutations: {
    update_application_id(state,flag){
      state.application_id=flag;
    },
    // 账号：
    userLogin(state, user_info) {
      for (var key in user_info) {
        state.user[key] = user_info[key]
        localStorage.setItem(key, state.user[key])
      }
      return state.user
    },
    keep_user_login(state) {
      if (state.user.user_id != '') return false
      for (var key in state.user) {
        state.user[key] = localStorage.getItem(key)
      }
    },
    user_logout(state) {//退出
      for (var key in state.user) {
        state.user[key] = ''
        localStorage.setItem(key, '')
      }
    },
    update_user(state, user_info) {//更改个人信息
      if (!user_info) return false
      for (var key in user_info) {
        state.user[key] = user_info[key]
        localStorage.setItem(key, state.user[key])
      }
    },
  	setIndexNav(state, obj) {//导航条
      state.index_nav = obj
    },
    //loading
    updateLoadingState(state,flag){
      state.isLoading=flag
    },
    updateNewStudent(state,val){
      state.is_register=val
    }
  },
  actions: {
    userLogin(context, user_info) {//验证码
      if (!user_info || !user_info.username || user_info.username == ''|| !user_info.verify_code || user_info.verify_code == '') return false

      var domain = window.location.host;
      var application_id=1;
      if(domain=='runyu.winlesson.com'||domain=='www.runyubisheng.com'){
        application_id = 300;
      }else if(domain=='www.winlesson.com'){
        application_id = 1;
      }

      axios.post(urls.login + "?username=" + user_info.username + "&verify_code=" + user_info.verify_code+ "&from=web"+ "&application_id=" + application_id).then(function(response) {
        if (response.data.code != 200) {
          alert(response.data.msg)
          return false
        }
        context.commit('userLogin', response.data.result.userinfo);
        context.commit('updateNewStudent', response.data.result.is_register);

      })
    },
    userLoginmima(context, user_info) {//密码
      if (!user_info || !user_info.username || user_info.username == ''|| !user_info.password || user_info.password == '') return false


      var domain = window.location.host;
      var application_id;
      if(domain=='runyu.winlesson.com'||domain=='www.runyubisheng.com'){
        application_id = 300;
      }else if(domain=='www.winlesson.com'){
        application_id = 1;
      }


      axios.post(urls.loginmima + "?username=" + user_info.username + "&password=" +  md5(user_info.password) + "&from=web"+ "&application_id=" + application_id).then(function(response) {
        if (response.data.code != 200) {
          alert(response.data.msg)
          return false
        }
        context.commit('userLogin', response.data.result.userinfo);
        context.commit('updateNewStudent', response.data.result.is_register);

      })
    },
    onLoading(context,flag){
      context.commit("updateLoadingState",flag);
    },
    update_application(context, application_id) {
      context.commit('update_application_id', application_id);
      document.title = "必胜课-必胜公考网-公考考研四六级考试-公务员考试一站式服务平台";
      var linkEle = document.getElementById("link1");
      linkEle.href = '../static/common/imgs/logo.ico';
      linkEle.type = 'image/x-icon';
      // axios.get(urls.getapplication + "?application_id=" + application_id).then(function(response) {
      //   if (response.data.code != 200) {
      //     alert("请求失败");
      //     return false;
      //   }
      //
      //
      //
      //   if(application_id==300){
      //
      //       //每秒循环一次，出现乐语就清空内容
      //       var timesRun = 0;
      //       var interval = setInterval(function(){
      //           timesRun += 1;
      //           if(timesRun === 20){
      //             clearInterval(interval);
      //           }
      //           $("#doyoo_f_chat").html('');//乐语
      //           $("#doyoo_f_chat").addClass('hide');
      //           document.getElementById('doyoo_f_chat').className='ddd';
      //       }, 1000);
      //
      //
      //       $("#doyoo_panel").addClass('hide');      //乐语
      //
      //
      //       $(".bsk_footer").addClass('hide');       //底边栏
      //       $("#downLoadapp").addClass('hide');          //顶部导航栏下载app按钮
      //       $("#bsk_aside_panel").addClass('hide');  //右侧qq二维码等
      //       $("#slpg").addClass('hide');   //申论批改
      //       $("#imgslogo").attr('src', response.data.app_info.app_logo);  //顶部logo
      //       $("#ul_login_Image2").attr('src',response.data.app_info.app_logo); //登录页logo
      //       $("#huancunimg").attr('src',response.data.app_info.qr_code);   //视频页缓存视频
      //
      //
      //
      //       var linkEle = document.getElementById("link1");
      //       linkEle.href = response.data.app_info.app_logo;
      //       linkEle.type = 'image/x-icon';
      //        document.title = response.data.app_info.app_name;
      //   }
      //   else if(application_id==1){
      //       var linkEle = document.getElementById("link1");
      //       linkEle.href = '../static/common/imgs/logo.ico';
      //       linkEle.type = 'image/x-icon';
      //       // document.title = "必胜公考网-公务员培训视频教程_面试笔试培训班_公务员网络在线教育培训机构";
      //     document.title = "必胜公考网";
      //     $("#imgslogo").attr('src', response.data.app_info.app_logo);  //顶部logo
      //   }
      //
      //
      //
      // })
    }
  },
  getters: {
    current_page: (state) => {
      return state.pages[state.current_page_id] || {}
    },
  },
}
export default new Vuex.Store(store)



// WEBPACK FOOTER //
// ./src/store/index.js